export { TextImage } from './TextImage';
